module.exports = __webpack_public_path__ + "static/WindingWorlds6-c3624cde835f2737a8c63eef1417223e.webp";